import { HSMSSelectOption } from '@components/shared';
import { lecture_material_categoryQuery } from '@app-types/graphql-types';

export const getCategoriesForSelect = (
  categories?: lecture_material_categoryQuery['lecture_material_category'],
): HSMSSelectOption[] => {
  if (categories) {
    const categoriesForSelect = categories.map((category) => {
      return {
        value: category.id,
        label: category.name,
      };
    });

    return categoriesForSelect.sort((firstValue, secondValue) => firstValue.label.localeCompare(secondValue.label));
  }

  return [];
};
